/** Row geometry shared by the rail's source rows and the patient queue nested under them. */

/** Selected row: background bleeds to the rail's right edge, with a 2px accent there. */
export const selectedEntrySx = {
    bgcolor: 'action.selected',
    color: 'text.primary',
    // Reach past the rail's right padding to its divider; extra right padding keeps the label off the edge.
    mr: '-12px',
    pr: '24px',
    position: 'relative' as const,
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: '-1px',
        width: '2px',
        bgcolor: 'primary.main',
    },
};

/** No width here: a fixed width defeats the negative-margin bleed above, stopping the highlight short of the divider. */
export const entryBaseSx = {
    display: 'flex',
    alignItems: 'center',
    // Force start (ButtonBase centers by default) so icon and text sit at the row's left edge.
    justifyContent: 'flex-start',
    // Keep full height so rows don't squish when the queue overflows the rail.
    flexShrink: 0,
    gap: 1.25,
    py: 1.25,
    px: 1.5,
    borderRadius: '4px 0 0 4px',
    textAlign: 'left' as const,
    color: 'text.secondary',
};

export const capSx = {
    fontSize: 10,
    letterSpacing: '0.06em',
    textTransform: 'uppercase' as const,
    color: 'text.secondary',
    px: 1.5,
    pb: 1,
};
